import { useMemo } from 'react';

import useLayoutConfigurations from '@hooks/Configurations/UseLayoutConfiguration';

const useHeaderLines = () => {
    const layoutConfigurations = useLayoutConfigurations();

    //compose string array for headerLine{n} (1 to 4) from layoutConfigurations, add item only if value is not empty. Keep right order. Strip empty values.
    const headerLines = useMemo(() => {
        return ['headerLine1', 'headerLine2', 'headerLine3', 'headerLine4']
            .map((key) => layoutConfigurations[key] || '')
            .filter((line) => line.trim());
    }, [layoutConfigurations]);

    return headerLines;
};

export default useHeaderLines;
